module.exports = __webpack_public_path__ + "img/officialSwiper1.7aa991c8.png";